class CustomerLanguageCurrency extends HTMLElement {
    constructor() {
        super();

        this.auth = this;
        this.header = this.closest('.section-header-navigation');
        this.mobileHeader = document.querySelector('.header-mobile');

        // The sidebar markup is normally nested inside the desktop header
        // section, which is hidden with CSS on mobile widths. Since a
        // hidden ancestor hides all its children (even position:fixed
        // ones), the sidebar never became visible when opened from the
        // mobile icon. Move it (and its overlay) to be a direct child of
        // <body> so it always renders regardless of which header section
        // triggered it.
        const overlay = this.nextElementSibling;
        if (this.parentElement !== document.body) {
            document.body.appendChild(this);
            if (overlay && overlay.classList && overlay.classList.contains('background-overlay1')) {
                document.body.appendChild(overlay);
            }
        }

        // Halo's own inline script (in header-navigation-hamburger.liquid)
        // only moves the actual language/currency widget markup into this
        // sidebar's ".halo-sidebar-wrapper" on desktop widths (>=1025px);
        // below that it moves the SAME widget into the mobile hamburger
        // menu instead, leaving the sidebar wrapper empty on mobile. That
        // script registers its own $(document).ready/resize handlers
        // earlier in the page than this deferred script runs, so re-doing
        // the move here (registered after) wins and keeps the widget in
        // the sidebar on every screen size.
        if (window.jQuery) {
            var forceSidebarWidget = function () {
                var pc = jQuery('.wrapper-language-currency');
                var sidebarWrapper = jQuery('.halo-language-currency-sidebar .halo-sidebar-wrapper');
                if (pc.length && sidebarWrapper.length && pc.parent()[0] !== sidebarWrapper[0]) {
                    pc.appendTo(sidebarWrapper);
                }
            };
            jQuery(document).ready(forceSidebarWidget);
            jQuery(window).on('resize', forceSidebarWidget);
        }

        if(document.querySelector('[data-open-lang-currency-sidebar]')){
            document.querySelectorAll('[data-open-lang-currency-sidebar]').forEach((openSidebar) =>
                openSidebar.addEventListener('click',this.setOpenSidebar.bind(this))
            );
        }

        if(document.querySelector('[data-close-lang-currency-sidebar]')){
            document.querySelector('[data-close-lang-currency-sidebar]').addEventListener(
                'click',
                this.setCloseSidebar.bind(this)
            );
        }

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

        // Floating quick-switch button, docked to the middle of the right
        // edge on every page/device — same idea as the theme's own
        // "recently viewed" side tab, just for language. Shows the
        // current language as a short code (EN / AR) and, since this
        // store only has two languages, a single tap switches straight
        // to the other one instead of opening the full sidebar.
        if (!document.querySelector('.og-lang-float-btn')) {
            var currentLocale = (window.Shopify && Shopify.locale) ? Shopify.locale : (document.documentElement.getAttribute('lang') || 'en');
            currentLocale = currentLocale.split('-')[0].toLowerCase();
            var otherLocale = currentLocale === 'ar' ? 'en' : 'ar';
            var flagByLocale = { en: '🇬🇧', ar: '🇪🇬' };

            var floatBtn = document.createElement('button');
            floatBtn.type = 'button';
            floatBtn.className = 'og-lang-float-btn';
            floatBtn.setAttribute('aria-label', 'Switch language');
            floatBtn.innerHTML =
                '<span class="og-lang-flag">' + (flagByLocale[currentLocale] || '') + '</span>' +
                '<span class="og-lang-code">' + currentLocale.toUpperCase() + '</span>';

            var floatStyle = document.createElement('style');
            // Halo's own "recently viewed" tab sits at the exact same spot
            // (top:50%; right:0; 40x40; z-index:99) -- pushed further up
            // so there's clear space between the two.
            floatStyle.textContent = '.og-lang-float-btn{position:fixed;top:calc(50% - 110px);right:0;z-index:100;display:flex;align-items:center;gap:4px;height:32px;padding:6px 12px 6px 10px;border-radius:16px 0 0 16px;background:#fff;border:none;box-shadow:0px 3px 7px 0px rgba(0,0,0,.2);cursor:pointer;color:#232323;font-size:13px;font-weight:600;letter-spacing:.5px;}.og-lang-float-btn:hover{background:#f5f5f5;}.og-lang-float-btn .og-lang-flag{font-size:15px;line-height:1;}';
            document.head.appendChild(floatStyle);

            document.body.appendChild(floatBtn);
            floatBtn.addEventListener('click', function (event) {
                event.preventDefault();
                var form = document.getElementById('HeaderLanguageForm');
                var input = form && form.querySelector('input[name="locale_code"]');
                if (form && input) {
                    input.value = otherLocale;
                    form.submit();
                } else {
                    // Localization form isn't in the DOM yet for some reason
                    // -- fall back to opening the full sidebar instead of
                    // doing nothing.
                    this.setOpenSidebar(event);
                }
            }.bind(this));
        }
    }

    setOpenSidebar(event){
        event.preventDefault();
        event.stopPropagation();
        document.body.classList.add('lang-currency-sidebar-show');
        if(this.header){ this.header.style.zIndex = '101'; }
        if(this.mobileHeader){ this.mobileHeader.style.zIndex = '101'; }
    }

    setCloseSidebar(event){
        event.preventDefault();
        event.stopPropagation();
        document.body.classList.remove('lang-currency-sidebar-show');
        setTimeout(() => {
            if(this.header){
                const index = this.header.dataset.index;
                this.header.style.zIndex = index || '';
            }
            if(this.mobileHeader){
                const mIndex = this.mobileHeader.dataset.index;
                this.mobileHeader.style.zIndex = mIndex || '';
            }
        }, 500)
    }

    onBodyClickEvent(event){
        if(document.body.classList.contains('lang-currency-sidebar-show')){
            if ((!this.contains(event.target)) && ($(event.target).closest('[data-open-lang-currency-sidebar]').length === 0)){
                this.setCloseSidebar(event);
            }
        }
    }
}

customElements.define('customer-language-currency', CustomerLanguageCurrency);